/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Print_DocumentInputs */

const en_orders_print_document = /** @type {(inputs: Orders_Print_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print`)
};

const es_orders_print_document = /** @type {(inputs: Orders_Print_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprimir`)
};

/**
* | output |
* | --- |
* | "Print" |
*
* @param {Orders_Print_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_print_document = /** @type {((inputs?: Orders_Print_DocumentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Print_DocumentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_print_document(inputs)
	return es_orders_print_document(inputs)
});